import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 sm:grid-cols-2 mx-x3 sm:m-0 md:mx-x8 gap-x-x2 md:gap-x-x8 gap-y-x4" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "mt-x1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "text-left" }

import { ref } from 'vue';
import { Hub, LocationClientService } from '@/types/locationServerApi';
import OutletOpeningHours from '@/shared/product/details/ui/outlet/OutletOpeningHours.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutletHubInfo',
  props: {
    hubId: null
  },
  setup(__props: any) {

const props = __props as {
    hubId: string;
}



const hub = ref<Hub | null>(null);

LocationClientService.getHubById(props.hubId).then((response) => {
    if (response.model) {
        hub.value = response.model;
    }
});

const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", null, _toDisplayString(_unref(labels).address), 1),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(hub.value?.street), 1),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(hub.value?.zipCode) + " " + _toDisplayString(hub.value?.city), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (hub.value?.nextDaysOpeningHours)
        ? (_openBlock(), _createBlock(OutletOpeningHours, {
            key: 0,
            "opening-hours": hub.value?.nextDaysOpeningHours
          }, null, 8, ["opening-hours"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})